import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { IAppRootState } from '../../core/store';
import { groupingTagReducer } from './grouping-tag.reducer';
import {
	GroupingTagMainSliceState,
	GroupingTagSliceKey,
} from './grouping-tag.state';

export const GroupingTagFeatureKey = 'grouping-tag';

export interface GroupingTagFeatureState {
	[GroupingTagSliceKey]: GroupingTagMainSliceState;
}

export interface GroupingTagRootState extends IAppRootState {
	[GroupingTagFeatureKey]: GroupingTagFeatureState;
}

export const featureSelector = createFeatureSelector<GroupingTagFeatureState>(
	GroupingTagFeatureKey
);

export const groupingTagReducers: ActionReducerMap<GroupingTagFeatureState> = {
	[GroupingTagSliceKey]: groupingTagReducer,
};
